import { Component, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-forest-description-disclaimer-overlay',
    templateUrl: './forest-description-disclaimer-overlay.component.html',
    styleUrls: ['./forest-description-disclaimer-overlay.component.css'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class ForestDescriptionDisclaimerOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
